export enum CountryCode {
  /**
   * @description 馬來西亞
   */
  MALAYSIA = 'MY',
}
